import type {User} from '../types';

export const getFirstName = (user: User | undefined): string | undefined => {
  return user?.name.split(' ')[0];
};
